/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9348b4de (Tue Jan 13 18:25:19 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The Event Category
 * @export
 * @enum {string}
 */
export enum EventCategory {
  Discover = 'Discover',
  Experience = 'Experience',
  Prepare = 'Prepare',
  LeadershipTraining = 'Leadership Training',
}

export function EventCategoryFromJSON(json: any): EventCategory {
  return EventCategoryFromJSONTyped(json, false)
}

export function EventCategoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EventCategory {
  return json as EventCategory
}

export function EventCategoryToJSON(value?: EventCategory | null): any {
  return value as any
}
